<template>
  <ChatModal :title="title" width="480px" @close="$emit('close')">
    <p v-if="!tags.length" class="text-muted mb-0">No records tagged.</p>
    <div v-for="t in tags" :key="t.type + t.id" class="tag-row" :class="{ 'tag-row--link': !!route(t) }" @click="open(t)">
      <span class="tag-row-icon"><i :class="icon(t.type)"></i></span>
      <div style="min-width: 0; flex: 1">
        <div class="font-weight-bold text-truncate">{{ t.label }}</div>
        <small class="text-muted">{{ typeLabel(t.type) }}<template v-if="t.sublabel"> · {{ t.sublabel }}</template></small>
      </div>
      <i v-if="route(t)" class="fe fe-chevron-right text-muted"></i>
    </div>
  </ChatModal>
</template>

<script>
import ChatModal from "./ChatModal.vue";
import chat from "../store";
import { entityRoute } from "../entityRoutes";
import { openTag } from "../openTag";

export const TYPE_ICONS = {
  enrollee: "fe fe-user",
  dependent: "fe fe-users",
  provider: "fe fe-home",
  authorization_code: "fe fe-key",
  claim: "fe fe-file-text",
  complaint: "fe fe-alert-circle",
  service_summary: "fe fe-activity",
  appointment: "fe fe-calendar",
  quality_assurance: "fe fe-check-square",
  form: "fe fe-clipboard",
  drug: "mdi mdi-pill",
  service: "fe fe-briefcase",
  payment_order: "fe fe-credit-card",
  finance: "fe fe-dollar-sign",
  change_provider: "fe fe-repeat",
  vendor: "fe fe-truck",
  inventory: "fe fe-package",
};

// The records tagged in a message. Clicking one checks access, then opens its page.
export default {
  name: "TagsModal",
  components: { ChatModal },
  props: {
    tags: { type: Array, default: () => [] },
    title: { type: String, default: "Tagged records" },
  },
  methods: {
    route(t) {
      return entityRoute(t.type, t.id);
    },
    icon(type) {
      return TYPE_ICONS[type] || "fe fe-hash";
    },
    typeLabel(type) {
      const t = (chat.state.entityTypes || []).find((x) => x.key === type);
      return t ? t.label : type.replaceAll("_", " ");
    },
    open(t) {
      openTag(this, t).then((opened) => opened && this.$emit("close"));
    },
  },
};
</script>

<style scoped>
.tag-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 8px;
  border-radius: 8px;
}
.tag-row + .tag-row {
  border-top: 1px solid #f1f5f9;
}
.tag-row--link {
  cursor: pointer;
}
.tag-row--link:hover {
  background: #f8fafc;
}
.tag-row-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #eef2ff;
  color: #2563eb;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  flex-shrink: 0;
}
</style>
